module.exports = __webpack_public_path__ + "static/media/g-hero.a7d3f814.png";